export default __webpack_public_path__ + "static/media/other.2bdf7e51.svg";